module.exports = __webpack_public_path__ + "img/JRCP.398b41ce.png";